import { render, staticRenderFns } from "./KeyStats.vue?vue&type=template&id=556989d2"
import script from "./KeyStats.vue?vue&type=script&lang=js"
export * from "./KeyStats.vue?vue&type=script&lang=js"
import style0 from "./KeyStats.vue?vue&type=style&index=0&id=556989d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports